<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
            <div class="row log-reg-form__list--check">
                <label class="checkbox -checkbox-long">
                    <span class="checkbox__text -black-checkbox-text log-reg-form__checkbox-text text-justify">
                        <h4>
                            {{ $t('I_ACCEPT') }}
                            <a class="log-reg-form__link" :href="eSklepUrl + $t('LINK_TERMS')" target="_blank">{{
                                $t('PRO_ACCOUNT_RODO_TERMS')
                            }}</a>
                        </h4>
                    </span>
                </label>
                <input
                    v-model="registryData.rulesAgreement"
                    class="checkbox__check-input validate-checkbox"
                    required
                    type="checkbox"
                    name
                    v-on:change="toggleDisabled"
                />
                <span class="checkbox__check">{{ $t('I_ACCEPT') }}</span>

                <div class="text-right">
                    <button class="btn-primary m-2 pa-2" :disabled="btnDisabledToggle" @click="$emit('agree')">
                        <span>Click Me</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from '../../main';

export default {
    name: 'termsAgreement',
    data() {
        return {
            btnDisabledToggle: true,
            registryData: {
                rulesAgreement: false,
            },
            eSklepUrl: config.eSklepUrl,
        };
    },
    methods: {
        toggleDisabled() {
            this.btnDisabledToggle = !this.btnDisabledToggle;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// termsAgreement.vue?8fa5e6e6